import React from 'react';
import { Link } from 'react-router-dom';
import { MdOutlineSecurity, MdOutlineCalculate, MdOutlineRule, MdCheckCircle, MdCancel } from 'react-icons/md';
import { HiTrendingUp } from "react-icons/hi";
import styles from "./Planejamento.module.css";
import img1 from "./img/img1.png";
import img2 from "./img/img2.png";

function PlanejamentoTributario() {
  return (
    <div className={styles.paginaGestao}>  
      <section className={styles.bannerGestao}>
        <div className={styles.bannerOverlay}>
          <div className={styles.bannerConteudo}>
            <h1>Planejamento Tributário</h1>
            <p>Otimize a carga tributária da sua corporação por meio de estratégias financeiras e fiscais rigorosamente fundamentadas na legislação vigente.</p>
            <Link to="/contato" className={`${styles.btnLink} ${styles.btnCyan}`}>Entre em Contato</Link>
          </div>
        </div>
      </section>
      <section className={`${styles.secaoGestao} ${styles.bgBranco}`}>
        <div className={styles.containerGrid}>
          
          <div className={styles.textos}>
            <h2 className={styles.tituloSecao}>Conceituação</h2>
            <h3 className={styles.subtituloAzul}>Inteligência Fiscal e Otimização de Recursos</h3>
            <p>O planejamento tributário consiste em um processo contínuo de estruturação corporativa com o objetivo de mitigar a carga fiscal de maneira estritamente legal e sustentável.</p>
            <p>Trata-se da aplicação técnica da elisão fiscal, uma prática que visa a máxima eficiência financeira, assegurando a total conformidade com as exigências dos órgãos reguladores.</p>
            
            <div className={styles.alertaContraste}>
              <div className={styles.alertaPositivo}>
                <MdCheckCircle className={styles.iconeAlertaP} />
                <div>
                  <strong>Planejamento Tributário (Elisão Fiscal)</strong>
                  <span>Aplicação estratégica da legislação para otimização fiscal (Prática Lícita).</span>
                </div>
              </div>
              <div className={styles.alertaNegativo}>
                <MdCancel className={styles.iconeAlertaN} />
                <div>
                  <strong>Sonegação Fiscal (Evasão Fiscal)</strong>
                  <span>Ocultação ou fraude de informações perante o fisco (Prática Ilícita).</span>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.imagemWrapper}>
            <img 
              src={img1} 
              alt="Análise de documentos fiscais e impostos" 
              className={styles.imagemEspaco} 
            />
          </div>

        </div>
      </section>
      <section className={`${styles.secaoGestao} ${styles.bgClaro}`}>
        <div className={`${styles.containerGrid} ${styles.gridInvertido}`}>        
          <div className={styles.imagemWrapper}>
            <img 
              src={img2} 
              alt="Reunião de escolha de regime tributário" 
              className={styles.imagemEspaco} 
            />
          </div>

          <div className={styles.textos}>
            <h2 className={styles.tituloSecao}>Escopo Analítico</h2>
            <p>Um planejamento tributário de excelência requer uma auditoria minuciosa de toda a cadeia operacional, comercial e financeira da instituição.</p>
            
            <div className={styles.gridEtapas}>
              <div className={styles.etapaCard}>
                <MdOutlineRule className={styles.etapaIcon} />
                <h4>1. Enquadramento Tributário</h4>
                <p>Avaliação criteriosa entre Simples Nacional, Lucro Presumido ou Lucro Real, considerando as normativas inerentes a cada regime.</p>
              </div>
              
              <div className={styles.etapaCard}>
                <MdOutlineCalculate className={styles.etapaIcon} />
                <h4>2. Diagnóstico Operacional</h4>
                <p>Mapeamento da natureza jurídica, volume de faturamento, estrutura de custos operacionais e despesas dedutíveis.</p>
              </div>

              <div className={styles.etapaCard}>
                <MdOutlineSecurity className={styles.etapaIcon} />
                <h4>3. Compliance Fiscal</h4>
                <p>Rigor na emissão documental, correta classificação de receitas e gestão estratégica de créditos tributários.</p>
              </div>

              <div className={styles.etapaCard}>
                <HiTrendingUp className={styles.etapaIcon} />
                <h4>4. Estratégias Lícitas</h4>
                <p>Maximização de incentivos fiscais, otimização da base de cálculo e estruturação sustentável na distribuição de dividendos.</p>
              </div>
            </div>
            
            <p className={styles.notaPratica}>
              <strong>Aplicação Prática:</strong> A readequação estratégica do regime de apuração pode resultar em uma expressiva preservação do capital de giro e mitigação de perdas ao longo do exercício fiscal.
            </p>
          </div>

        </div>
      </section>
      <section className={`${styles.secaoGestao} ${styles.bgBranco}`}>
        <div className={styles.containerGrid}>
          
          <div className={styles.textos}>
            <h2 className={styles.tituloSecao}>Modelos de Atuação</h2>
            <h3 className={styles.subtituloAzul}>Abordagens Estratégicas por Cenário</h3>
            <p>A elisão fiscal visa mitigar o impacto tributário e elidir recolhimentos indevidos, maximizando assim a rentabilidade líquida da corporação em estrita observância à legalidade.</p>
            <p>Para atingir tais objetivos, a nossa metodologia é aplicada sob três perspectivas temporais e situacionais distintas.</p>
            <Link to="/contato" className={`${styles.btnLink} ${styles.btnAzul}`} style={{marginTop: '1.5rem'}}>
              Agendar Diagnóstico Tributário
            </Link>
          </div>

          <div className={styles.tiposContainer}>
            <div className={styles.tipoItem}>
              <div className={styles.tipoLinhaCyan}></div>
              <div>
                <h4>Preventivo</h4>
                <p>Elaborado previamente à ocorrência do fato gerador. É a abordagem mais segura, indicada para o planejamento do exercício fiscal ou estruturação de novas operações.</p>
              </div>
            </div>

            <div className={styles.tipoItem}>
              <div className={styles.tipoLinhaAzul}></div>
              <div>
                <h4>Corretivo</h4>
                <p>Incide sobre operações em andamento. Focado na retificação de inconsistências fiscais e na recuperação de tributos recolhidos indevidamente.</p>
              </div>
            </div>

            <div className={styles.tipoItem}>
              <div className={styles.tipoLinhaCyan}></div>
              <div>
                <h4>Estratégico</h4>
                <p>Direcionado à expansão corporativa. Estrutura a matriz tributária para operações de fusão, aquisição, abertura de filiais ou lançamento de novas linhas de negócio.</p>
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}

export default PlanejamentoTributario;